import * as z from "zod/v4";

export const deleteWorkOrderViewFolder = {
  name: "deleteWorkOrderViewFolder" as const,
  input: z.object({ folderId: z.string() }),
  output: z.object({}),
};
